import { api_Secret, api_key } from "../config/appSettings";
import { endpoints } from "../config/endpoints";
import axiosConfig from "../utils/axiosConfig";
// import objToSearchParam from "../utils/objToSearchParam";
import storeInit from "../redux/store";


// Old All Aboard - starts
export const sendSMS = async (msisdn, msg) => {
  let phone = msisdn.substring(0, 3) === "255" ? msisdn : `255${msisdn}`;
  return await axiosConfig(endpoints.sendSMS, "post", {
    phoneNumber: phone,
    body: msg,
  });
};

export const firstPayment = async (body) => {
  return await axiosConfig(endpoints.autoDebitPayment, "post", body);
};
// Old All Aboard - ends


// New All Aboard - starts
export const fetchCorporateTypes = async () => {
  const res = await axiosConfig(`${endpoints.corporateTypes}`, "get");
  const resData = res.data;

  return resData;
};

export const getNetworkProviders = async () => {
  const res = await axiosConfig(endpoints.getNetworkProviders, "get");
  const data = res.data;

  return data;
};

export const prequalifyUserDetails = async (payload) => {
  const res = await axiosConfig(endpoints.prequalify, "post", payload);
  const resData = res.data;

  return resData;
};

export const fetchAllPartners = async (payload) => {
  const res = await axiosConfig(`${endpoints.fetchPartners}`, "get");
  const resData = res.data;

  return resData;
};

export const verifyUserOtp = async (payload) => {
  const res = await axiosConfig(endpoints.validateUserOtp, "post", payload);
  const resData = res.data;

  return resData;
};

export const resendUserOtp = async (payload) => {
  const res = await axiosConfig(endpoints.resendUserOtp, "post", payload);
  const resData = res.data;

  return resData;
};

export const userLivenessCheck = async (msisdn) => {
  const res = await axiosConfig(`${endpoints.livenessCheck}/${msisdn}`, "post");
  const resData = res.data;

  return resData;
};

export const userLivenessCheckVerify = async (msisdn) => {
  const res = await axiosConfig(
    `${endpoints.livenessCheckVerify}/${msisdn}`,
    "get"
  );
  const resData = res.data;

  return resData;
};

export const fetchUserBundles = async (payload) => {
  const token =
    storeInit.store.getState()?.user?.user?.accessTokens?.token?.token;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      source: "web",
      api_key: api_key,
      api_Secret: api_Secret,
    },
  };

  const res = await axiosConfig(
    `${endpoints.fetchBundles}?api_key=1&api_secret=1`,
    "post",
    JSON.stringify(payload),
    config
  );
  const resData = res.data;

  return resData;
};

export const fetchEequityContributionUserBundles = async (payload) => {
  const token =
    storeInit.store.getState()?.user?.user?.accessTokens?.token?.token;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      source: "web",
      api_key: api_key,
      api_Secret: api_Secret,
    },
  };

  const res = await axiosConfig(
    `${endpoints.fetchEequityContributionBundles}?api_key=1&api_secret=1`,
    "post",
    JSON.stringify(payload),
    config
  );
  const resData = res.data;

  return resData;
};

export const filterBundlesBYDeviceName = async (payload) => {
  const token =
    storeInit.store.getState()?.user?.user?.accessTokens?.token?.token;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      source: "web",
      api_key: api_key,
      api_Secret: api_Secret,
    },
  };

  const res = await axiosConfig(
    `${endpoints.filterBundlesByDeviceName}?api_key=1&api_secret=1`,
    "post",
    JSON.stringify(payload),
    config
  );
  const resData = res.data;

  return resData;
};

export const submitUserBundle = async (payload) => {
  const token =
    storeInit.store.getState()?.user?.user?.accessTokens?.token?.token;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      source: "web",
      api_key: api_key,
      api_Secret: api_Secret,
    },
  };

  const res = await axiosConfig(
    `${endpoints.submitSelectedBundle}`,
    "post",
    JSON.stringify(payload),
    config
  );
  const resData = res.data;

  return resData;
};

export const uploadUserFile = async (payload) => {
  const res = await axiosConfig(`${endpoints.uploadFiles}`, "post", payload);
  const resData = res.data;

  return resData;
};

export const addUpdateKyc = async (payload) => {
  const res = await axiosConfig(`${endpoints.addUpdateKyc}`, "post", payload);
  const resData = res.data;

  return resData;
};

export const submitCustomerKycData = async (payload, financierCode) => {
  const res = await axiosConfig(
    `${endpoints.submitCustomerKyc}?financierCode=${financierCode}`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

export const updateCustomerOnboardingStat = async (msisdn, status) => {
  const res = await axiosConfig(
    `${endpoints.updateOnboardStatus}?msisdn=${msisdn}&status=${status}`,
    "post"
  );
  const resData = res.data;

  return resData;
};

export const getPrecustomerDetails = async (preCustomerId) => {
  const res = await axiosConfig(
    `${endpoints.fetchPrecustomerDetails}/${preCustomerId}`,
    "get"
  );
  const resData = res.data;

  return resData;
};

export const sideloadingDevice = async (payload) => {
  const res = await axiosConfig(
    `${endpoints.sideloading}/AionServ/qrcode?telco=MTN`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

export const completeSideloadingDevice = async (sessionId) => {
  return await axiosConfig(`${endpoints.completeSideloading}?sessionnId=${sessionId}`, "post");
};

export const getDeviceImei = async (payload) => {

  const res = await axiosConfig(
    `${endpoints.getPrecustomerDeviceImei}`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

export const registerUserDevice = async (payload) => {

  const res = await axiosConfig(
    `${endpoints.deviceRegisteration}/Device/register-aion-device`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

export const releaseCustomerDevice = async (payload) => {

  const res = await axiosConfig(
    `${endpoints.releaseDevice}?precustomerid=${parseInt(
      payload.precustomerid
    )}&repid=${payload.repid}`
  );
  const resData = res.data;

  return resData;
};

export const fetchAllStores = async () => {
  const res = await axiosConfig(`${endpoints.fetchStore}`);
  const resData = res.data;

  return resData;
};

export const fetchAllStoresByFinancier = async (payload) => {
  const res = await axiosConfig(`${endpoints.fetchStore}?SearchText=${payload?.searchText}&pageSize=${payload?.pageSize}`);
  const resData = res.data;

  return resData;
};

export const getStoreBySearchCode = async (store_code) => {
  const res = await axiosConfig(
    `${endpoints.searchStoreByCode}?storeCode=${store_code}`
  );
  const resData = res.data;

  return resData;
};

export const getCustomersInProgress = async (rep_id) => {
  const res = await axiosConfig(
    `${endpoints.fetchCustomersInProgress}?rep_id=${rep_id}`
  );
  const resData = res.data;

  return resData;
};

export const getCustomersOnboarded = async (rep_id) => {
  const res = await axiosConfig(
    `${endpoints.fetchCustomersOnboarded}?rep_id=${rep_id}`
  );
  const resData = res.data;

  return resData;
};

export const getSearchedCustomersOnboarded = async (msisdn) => {
  const res = await axiosConfig(
    `${endpoints.searchCustomersOnboarded}?msisdn=${msisdn}`
  );
  const resData = res.data;

  return resData;
};

export const getPaymentHistory = async (customer_id) => {
  const res = await axiosConfig(
    `${endpoints.fetchLoanRepayHistory}?customerid=${customer_id}`
  );
  const resData = res.data;

  return resData;
};

export const activateCustomerBundle = async (payload) => {
  const res = await axiosConfig(
    `${endpoints.activateBundle}?msisdn=${payload.msisdn}`,
    "post"
  );
  const resData = res.data;

  return resData;
};

export const getTermsAndConditions = async (payload) => {
  const res = await axiosConfig(
    `${endpoints.fetch_TandC}?precustomerId=${payload?.preCustomerId}&partnerid=${payload?.partnerid}`,
    "get"
  );
  const resData = res.data;

  return resData;
};

export const changeUserPhoneNum = async (payload) => {
  const res = await axiosConfig(
    `${endpoints.changePhoneNumCorporate}/update-corporate-customer-msisdn`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

export const checkFBNDeviceExistance = async (payload) => {

  const res = await axiosConfig(
    `${endpoints.checkFBNDeviceExistance}`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

export const fetchFBNBundlesByDeviceId = async (payload) => {

  const res = await axiosConfig(
    `${endpoints.fetchFBNBundlesByDeviceId}`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

export const fbnSubmitCustomerBundle = async (payload) => {

  const res = await axiosConfig(
    `${endpoints.fbnSubmitCustomerBundle}`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

export const fetchDeviceByTenure = async (payload) => {

  const res = await axiosConfig(
    `${endpoints.fetchDeviceByTenure}`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

export const fetchBundleTenureByDeviceId = async (payload) => {

  const res = await axiosConfig(
    `${endpoints.fetchBundleTenureByDeviceId}`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

export const fbnSumitPrequalForm = async (payload) => {

  const res = await axiosConfig(
    `${endpoints.fbnSumitPrequalForm}`,
    "post",
    payload
  );
  const resData = res.data;

  return resData;
};

// New All Aboard - ends
